var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "500px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-btn",
        {
          attrs: { slot: "activator", dark: "", small: "", round: "" },
          slot: "activator"
        },
        [_c("v-icon", [_vm._v("add")])],
        1
      ),
      _vm._v(" "),
      _c("v-card", [
        _c(
          "form",
          {
            attrs: { "close-on-content-click": false },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.createStory.apply(null, arguments)
              }
            }
          },
          [
            _c("v-card-title", { staticStyle: { "padding-bottom": "0" } }, [
              _c("span", { staticClass: "headline" }, [
                _vm._v(
                  _vm._s(
                    !_vm.story || _vm.newStory.id === "" ? "New" : "Edit"
                  ) + " Story"
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "v-card-text",
              [
                _c(
                  "v-container",
                  {
                    staticStyle: { "padding-top": "0px" },
                    attrs: { "grid-list-sm": "" }
                  },
                  [
                    _c(
                      "v-layout",
                      { attrs: { wrap: "" } },
                      [
                        _vm.steps.step1 && !_vm.steps.step2
                          ? [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Project Title",
                                      rules: [_vm.checkTitle],
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.newStory.title,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newStory, "title", $$v)
                                      },
                                      expression: "newStory.title"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Story Subtitle (optional)"
                                    },
                                    model: {
                                      value: _vm.newStory.subtitle,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newStory, "subtitle", $$v)
                                      },
                                      expression: "newStory.subtitle"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Organization (optional)" },
                                    model: {
                                      value: _vm.newStory.organization,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.newStory,
                                          "organization",
                                          $$v
                                        )
                                      },
                                      expression: "newStory.organization"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "author (optional)" },
                                    model: {
                                      value: _vm.newStory.author,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newStory, "author", $$v)
                                      },
                                      expression: "newStory.author"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: { label: "Team (optional)" },
                                    model: {
                                      value: _vm.newStory.team,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newStory, "team", $$v)
                                      },
                                      expression: "newStory.team"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.steps.step2
                          ? [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.experiences.options,
                                      chips: "",
                                      label: "Device"
                                    },
                                    on: { change: _vm.experienceChanged },
                                    model: {
                                      value:
                                        _vm.experiences
                                          .experienceSelectedOption,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.experiences,
                                          "experienceSelectedOption",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "experiences.experienceSelectedOption"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _vm.experiences.experienceSelectedOption ===
                                  "Mobile"
                                    ? _c("v-autocomplete", {
                                        attrs: {
                                          items:
                                            _vm.experiences
                                              .mobileExperienceOptions,
                                          chips: "",
                                          label: "Experience"
                                        },
                                        model: {
                                          value:
                                            _vm.experiences
                                              .mobileExperienceSelectedOption,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.experiences,
                                              "mobileExperienceSelectedOption",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "experiences.mobileExperienceSelectedOption"
                                        }
                                      })
                                    : _vm.experiences
                                        .experienceSelectedOption === "HMD"
                                    ? _c("v-autocomplete", {
                                        attrs: {
                                          items:
                                            _vm.experiences
                                              .hmdExperienceOptions,
                                          chips: "",
                                          label: "Experience"
                                        },
                                        model: {
                                          value:
                                            _vm.experiences
                                              .hmdExperienceSelectedOption,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.experiences,
                                              "hmdExperienceSelectedOption",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "experiences.hmdExperienceSelectedOption"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.experiences.mobileExperienceSelectedOption ===
                                "AR" ||
                              _vm.experiences.hmdExperienceSelectedOption ===
                                "AR"
                                ? _c(
                                    "v-flex",
                                    { attrs: { xs12: "" } },
                                    [
                                      _c("v-autocomplete", {
                                        attrs: {
                                          items: _vm.experiences.arOptions,
                                          chips: "",
                                          label: "AR Options"
                                        },
                                        model: {
                                          value:
                                            _vm.experiences.arSelectedOption,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.experiences,
                                              "arSelectedOption",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "experiences.arSelectedOption"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass:
                                    "text-xs-center text-sm-center text-md-center text-lg-center",
                                  attrs: { xs12: "" }
                                },
                                [
                                  _vm.newStory.imageUrl
                                    ? _c("img", {
                                        attrs: {
                                          src: _vm.newStory.imageUrl,
                                          height: "150"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Select Image",
                                      "prepend-icon": "attach_file"
                                    },
                                    on: { click: _vm.pickFile },
                                    model: {
                                      value: _vm.newStory.imageName,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newStory, "imageName", $$v)
                                      },
                                      expression: "newStory.imageName"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    ref: "image",
                                    staticStyle: { display: "none" },
                                    attrs: { type: "file", accept: "image/*" },
                                    on: { change: _vm.onFilePicked }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: [
                                        "Late Night Show",
                                        "Keyword Two",
                                        "Keyword Three"
                                      ],
                                      multiple: "",
                                      chips: "",
                                      label: "keywords (optional)"
                                    },
                                    model: {
                                      value: _vm.newStory.topics,
                                      callback: function($$v) {
                                        _vm.$set(_vm.newStory, "topics", $$v)
                                      },
                                      expression: "newStory.topics"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "green lighten-1", flat: "" },
                    nativeOn: {
                      click: function($event) {
                        _vm.dialog = false
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _vm.steps.step1 && !_vm.steps.step2
                  ? _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "green lighten-1",
                          flat: "",
                          type: "submit",
                          disabled: _vm.isDisabled
                        }
                      },
                      [_vm._v("Next")]
                    )
                  : _c(
                      "v-btn",
                      {
                        attrs: {
                          color: "green lighten-1",
                          flat: "",
                          type: "submit",
                          disabled: _vm.isDisabled
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              !_vm.story || _vm.newStory.id === ""
                                ? "Create"
                                : "Update"
                            ) +
                            "\n        "
                        )
                      ]
                    )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-79201686", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79201686","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-list-view/createStory.vue
// module id = null
// module chunks = 